import React from "react";
import StackNavigator from "../../components/StackNavigator";
import Auth from "./Auth";
import ForgotPassword from "./ForgotPassword";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import VerifyAccount from "./VerifyAccount";

function AuthScreens() {
  const SCREENS = [
    { name: "auth", component: Auth },
    { name: "signup", component: SignUp },
    { name: "signin", component: SignIn },
    { name: "forgot", component: ForgotPassword },
    { name: "verify", component: VerifyAccount },
  ];
  return <StackNavigator screens={SCREENS} />;
}

export default AuthScreens;
